import './FilterTreeHorizontalPlaceholder.scss';

import { ArrowIcon } from '@components/Icon/Arrow';
import Placeholder from '@components/Placeholder';
import { createClsNameMap } from '@utils';

export const clsNameMap = createClsNameMap({
  elements: {
    group: createClsNameMap({}),
  },
})('filter-tree-horizontal-placeholder');

export type PlaceholderProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  rows?: number;
};

const FilterTreeHorizontalPlaceholder = ({ rows = 4, ...attrs }: PlaceholderProps) => {
  const arr = new Array(rows).fill('item');
  return (
    <div className={clsNameMap.root()} {...attrs}>
      {arr.map((_, i) => {
        return (
          <div key={i} className={clsNameMap.elm('group')}>
            <Placeholder width={80} />
            <ArrowIcon style={{ marginLeft: 15 }} modifiers={['down']} />
          </div>
        );
      })}
    </div>
  );
};

export default FilterTreeHorizontalPlaceholder;
